module.exports = __webpack_public_path__ + "static/media/blue-wave-top.9f1a80b0.svg";